import React from 'react'
import { FormattedMessage } from 'react-intl'
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  DialogActions,
  Slide
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import WarningIcon from '@material-ui/icons/Warning'
import { useStyles } from './Styles'
import { PageConsumer, PageProvider } from '../../../../PageContext'
import { FormLoader } from '../../../Loader/FormLoader'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const DeletePage = ({
                      index, data, setData, count, setCount, adminSectionType, handleNotificationCall,
                      handleDeletePageDialog, viewDeletePageDialog, openDeletePageDialog
                    }) => {
  const classes = useStyles()

  return (
    <PageProvider adminSectionType={adminSectionType} pageAction={'delete'} handleNotificationCall={handleNotificationCall}>
      <PageConsumer>
        {({ deletePageLoading, handleDeletePage }) => (
          <>
            {!!viewDeletePageDialog &&
            <Dialog
              keepMounted
              fullWidth
              maxWidth={'sm'}
              open={openDeletePageDialog}
              classes={{ paper: classes.NewOrderDialogPaper }}
              TransitionComponent={Transition}
              onClose={handleDeletePageDialog}
              aria-labelledby="BasicInfoDialog"
              aria-describedby="BasicInfoDialog"
            >
              <IconButton
                edge={false}
                className={classes.NewOrderDialogClose}
                color="inherit"
                aria-label="close dialog"
                onClick={handleDeletePageDialog}
              >
                <CloseIcon/>
              </IconButton>
              <DialogContent className={classes.NewOrderDialogContent}>
                {!!deletePageLoading && <FormLoader loading={true}/>}
                <Box px={4} pt={4} pb={1} className={classes.DeleteOrderWrapper}>
                  <WarningIcon className={classes.DeleteWarningIcon}/>
                  <p><FormattedMessage id='Page.DeleteMessage' values={{ title: data[index].title }}/></p>
                </Box>
              </DialogContent>
              <DialogActions className={classes.NewOrderDialogFooter}>
                <Button size="large" variant="contained" color="primary" className={classes.DeleteOrderBtn}
                        onClick={() => {
                          handleDeletePage(index, data, setData,count, setCount, handleDeletePageDialog)
                        }}>
                  <FormattedMessage id='Page.Action.Delete'/>
                </Button>
                <Button onClick={handleDeletePageDialog} color="primary">
                  <FormattedMessage id='ChangePhone.DialogActions.cancel'/>
                </Button>
              </DialogActions>
            </Dialog>
            }
          </>
        )}
      </PageConsumer>
    </PageProvider>
  )
}

export default DeletePage
